export const FAQS = [
  {
    q: "Do I need to install anything?",
    a: "No. DPL Jade runs entirely in your browser — Chrome, Firefox, Edge, or Safari. No plugins, no downloads.",
  },
  {
    q: "Is my data safe?",
    a: "On the free plan your work is stored in your browser's localStorage — it never leaves your device. On Pro and Team plans, projects sync to our Supabase-powered backend with row-level security, meaning only you (or your team) can read your data.",
  },
  {
    q: "What happens if I clear my browser cache on the free plan?",
    a: "Your project will be lost because localStorage is tied to that browser. We recommend upgrading to Pro for persistent cloud saves, or exporting a PDF before clearing cache.",
  },
  {
    q: "How is the BOQ cost calculated?",
    a: "Costs are based on material volume (length × thickness × height), minus openings, multiplied by per-m³ or per-m² rates for each material type. Labour is added as a flat 25% of material cost. Floor and wall-finish costs use per-m² rates by room type. All rates are editable in the material library (Team plan).",
  },
  {
    q: "Can I use DPL Jade for commercial / client projects?",
    a: "Yes. The Pro and Team plans are designed for professional use. White-label PDF export (Team) lets you remove DPL Jade branding from reports.",
  },
  {
    q: "What payment methods do you accept?",
    a: "UPI, debit/credit cards (Visa, Mastercard, RuPay), and net banking — processed securely via Razorpay. We do not store card details.",
  },
  {
    q: "Can I cancel my subscription?",
    a: "Yes, at any time from your account settings. You retain Pro/Team access until the end of your paid billing period.",
  },
  {
    q: "Do you offer refunds?",
    a: "If you cancel within 7 days of your first payment and haven't used cloud sync features, we'll issue a full refund. Contact info@dplhomestar.com.",
  },
  {
    q: "Is there a student or NGO discount?",
    a: "Yes — write to info@dplhomestar.com with proof of enrollment / registration and we'll apply a 50% discount.",
  },
  {
    q: "Will there be a mobile app?",
    a: "DPL Jade is fully responsive on desktop. A dedicated mobile/tablet app is on the roadmap for 2025.",
  },
];
